const paypalSelector = store => store.paypal;

export default paypalSelector;
